import useVerifiedOnMobileInstructions from '../Utils/useVerifiedOnMobileInstructions';
import ContentLink from './ContentLink';
import InstructionsSpanTypography from './InstructionsSpanTypography';
import UIStrings from '@/Utils/UIStrings';

function VerifiedOnMobileInstructions() {
    const { proceedToProductHandler } = useVerifiedOnMobileInstructions();
    return (
        <div className="text-sm leading-relaxed">
            <InstructionsSpanTypography>{`${UIStrings.IfIHaveAlreadyVerifiedOnMyMobileDevice} `}</InstructionsSpanTypography>
            <ContentLink onClick={proceedToProductHandler}>{UIStrings.ClickHereToProceed}</ContentLink>
            <InstructionsSpanTypography>{` ${UIStrings.ToTalentmesh}`}</InstructionsSpanTypography>
        </div>
    );
}

export default VerifiedOnMobileInstructions;
